export const TOGGLE_NOTIFICATION_SOUND = 'TOGGLE_NOTIFICATION_SOUND';

export const toggleNotificationSound = (dispatch, getState) => {
  const { sound } = getState().notification;
  dispatch({ type: TOGGLE_NOTIFICATION_SOUND, payload: !sound });
};
